import { useMutation, useQuery } from "@tanstack/react-query";
import { Module, QueryKeyTypes } from "../../../assets/types/common";
import { Constants } from "../../../assets/utils/lib/constants";
import { SearchDto } from "../../../assets/utils/lib/searchDto";
import { IActionResponse, IActionResult, LookupGroupClient, LookupTypeClient } from "../../../services/proxies";
import { ViewProps } from "../props";

export class LookupGroupService<T extends ViewProps.GroupTypeDto> {
    private lookupTypeClient: LookupTypeClient<ViewProps.CategoryTypeDto>;
    private lookupGroupClient: LookupGroupClient<T>;
    public constructor(moduleType: Module) {
        this.lookupGroupClient = new LookupGroupClient<T>(moduleType);
        this.lookupTypeClient = new LookupTypeClient<ViewProps.CategoryTypeDto>(moduleType);
    }

    save = () =>
        useMutation<IActionResult<T>, Error, T>({
            mutationFn: async (payload: T) => {
                return await this.lookupGroupClient.saveLookupGroupAsync(payload);
            },
        });

    getLookupGroupQuery = (id: string | undefined) =>
        useQuery({
            queryKey: [ViewProps.LookupGroupQueryKeys[QueryKeyTypes.Get], id],
            queryFn: async () => {
                return await this.lookupGroupClient.getLookupGroupAsync(id)
            },
            enabled: Boolean(id) && id !== Constants.emptyGuid,
        });

    getLookupGroupsQuery = (typeId: string | undefined) =>
        useQuery({
            queryKey: [ViewProps.LookupGroupQueryKeys[QueryKeyTypes.GetAll], typeId],
            queryFn:
                async () => await this.lookupGroupClient.getLookupGroupsAsync(typeId),
            enabled: Boolean(typeId),
        });

    getLookups = () =>
        useQuery({
            queryKey: [ViewProps.LookupGroupQueryKeys[QueryKeyTypes.Lookup]],
            queryFn: async () => {
                return await this.lookupTypeClient.getLookupTypesAsLookupAsync()
            }
        });

    gridQuery = (searchQuery: SearchDto) =>
        useQuery({
            queryKey: [ViewProps.LookupGroupQueryKeys[QueryKeyTypes.Grid], searchQuery],
            queryFn: async () =>
                await this.lookupGroupClient.searchLookupGroupsAsync(searchQuery),
        });

    deActivate = () =>
        useMutation<IActionResponse, Error, string>({
            mutationFn: async (id: string | undefined) => {
                return await this.lookupGroupClient.deleteLookupGroupAsync(id);
            },
        });
}